<template>
  <div class="installation-container">
    <div class="installation-wrapper">
      <div
        v-if="$route.path !== '/setup/welcome' && $route.path !== '/setup/activation-key' && $route.path !== '/setup/enter-trial-key' && $route.path !== '/setup/select-installation-type'"
        class="installation-header"
      >
        <div class="col-3">
          <img v-if="OrgImage" :src="URL_BASE+OrgImage" height="auto" width="120" alt />
          <img v-else src="@/assets/img/logos/logo-dark.png" height="auto" width="100" />
        </div>

        <div class="col-6 text-center">
          <div class="installation-title">{{$route.name}}</div>
        </div>
        <div class="col-3 text-right">
          <h5>{{client_name}}</h5>
        </div>
      </div>

      <router-view />
    </div>
  </div>
</template>

<script>
import { BASEURL } from "@/config/index";

export default {
  data() {
    return {
      URL_BASE: BASEURL
    };
  },
  computed: {
    client_name: function() {
      return this.secureStore.get("ORGNAME");
    },
    OrgImage: function() {
      return this.$store.getters.getOrgImage;
    }
  },

  mounted() {
    console.log(
      'this.secureStore.get("ORGNAME") :',
      this.secureStore.get("ORGNAME")
    );
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/Installation/installationWrapper.vue